import { Store as $store } from '@store';
import { notify, notificationTypes } from '@utils/notifications';

/**
 * Check today's task with specified interval
 */
export const notifyUserAboutDaily = (interval) => {
  const isLoggedIn = $store.getters['app/isLoggedIn'];
  const isAdminOrStaff = $store.getters['app/isAdminOrStaff'];
  if (!isLoggedIn || !isAdminOrStaff) {
    return;
  }
  const tasksCount = $store.getters['app/todayTasksCount'];
  const lsKey = 'quantum-user-daily-notified';
  const notifyTimestamp = window.localStorage.getItem(lsKey) || 0;
  // Notify every 12 hours
  const isNotified = Date.now() - notifyTimestamp < 1000 * 60 * 60 * 12;

  const closeNotification = () => {
    window.localStorage.setItem(lsKey, Date.now());
  };

  if (tasksCount && !isNotified) {
    notify({
      type: notificationTypes.INFO,
      title: 'Daily Tasks Reminder',
      message: `Good day! There ${tasksCount > 1 ? 'are' : 'is'}
      ${tasksCount} open task${tasksCount > 1 ? 's' : ''} today.`,
      link: '/tasks',
      linkTitle: 'Open Tasks',
      timeout: 0,
      actions: [{
        label: 'Hide for 12 hours',
        handler: closeNotification,
      }],
    });
  }

  if (interval) {
    setInterval(async () => {
      notifyUserAboutDaily();
    }, interval);
  }
};

export const getTodayTasks = (interval) => {
  const user = $store.getters['app/user'];
  const isAdminOrStaff = $store.getters['app/isAdminOrStaff'];

  if (!user || !isAdminOrStaff) {
    return;
  }

  $store.dispatch('app/getTodayTasks');

  if (interval) {
    setInterval(async () => {
      await $store.dispatch('app/getTodayTasks');
    }, interval);
  }
};
